// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "3cd0d2ff886cb08ca5e1" + ".js";
};